import React from "react";

const BreadcrumbOption = (props) => {
  return (
    <div className="breadcrumb-option spad">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="bo-links">
              <a href="./index.html">
                <i className="fa fa-home"></i> {props.home}
              </a>
              <span>{props.current}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbOption;
